<template>
  <app-shell>
    <vnt-header class="header">Categories</vnt-header>
    <vnt-button class="add-button" :click="addCategory">Add</vnt-button>
    <categories-list />
  </app-shell>
</template>

<script>
import AppShell from '@/components/AppShell.vue'
import CategoriesList from '@/components/categories/CategoriesList.vue'

export default {
  name: 'CategoriesView',

  components: {
    AppShell,
    CategoriesList
  },

  methods: {
    addCategory() {
      this.$router.push('/categories/add')
    }
  }
}
</script>

<style scoped>
.header {
  margin-bottom: 40px;
}

.add-button {
  margin-bottom: 20px;
}
</style>
